import { render, staticRenderFns } from "./plain-editor.vue?vue&type=template&id=31a22834&scoped=true&"
import script from "./plain-editor.vue?vue&type=script&lang=js&"
export * from "./plain-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a22834",
  null
  
)

export default component.exports